/*
 * 犬｜タブでの絞り込み
 *
 * 「単品で購入」の 冷凍 / レトルト の切り替え。ページ遷移はせず、表示だけを入れ替える。
 * タブと対象は data 属性で結び、セクションが複数あっても互いに干渉しない。
 */

(() => {
  if (window.inuTabsReady) return;
  window.inuTabsReady = true;

  const activate = (root, name) => {
    root.querySelectorAll('[data-inu-tab]').forEach((tab) => {
      const on = tab.dataset.inuTab === name;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    root.querySelectorAll('[data-inu-tab-panel]').forEach((panel) => {
      // タブ名が空の項目は、どのタブでも出す
      const target = panel.dataset.inuTabPanel;
      panel.hidden = target !== '' && target !== name;
    });
  };

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-inu-tab]');
    if (!tab) return;
    const root = tab.closest('[data-inu-tabs]');
    if (!root) return;
    event.preventDefault();
    activate(root, tab.dataset.inuTab);
  });
})();
